import {ChangeDetectorRef, Component, ElementRef,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {CommonFieldService} from "../../../../../services/common/common-field.service";
import {AccountType} from "../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {AllocationFormBaseComponent} from "./allocation-form-base.component";
import {FieldRecord} from "../../../../../model/api/field-record";
import {ApsIdFormat} from "../../../../../model/clearing/aps-id-format";
import {AppConfigService} from "../../../../../services/app-config.service";
import {CcStorageService} from "../../../../../services/common/cc-storage.service";
import {FieldsService} from "../../../../../services/common/fields-service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ]
})
export class SingleAllocationFormBaseComponent extends AllocationFormBaseComponent {

  clearingExchApsIdFormatMap: any = {string: ApsIdFormat};

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              protected allocationService: ClearingAllocationService,
              protected commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref, allocationService, commonFieldService, messageService,
      confirmationService, translateService, fieldsService, storageService, appConfigService);
  }

  loadData() {
    super.loadData();
    this.clearingExchApsIdFormatMap = this.appConfigService.clearingExchApsIdFormatMap;
  }

  protected initConfigs() {
    super.initConfigs();
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'orderReference',
            column: 2,
            type: TYPE.TEXT,
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.orderReference = inputField.value;
              inputField.setSelectionRange(start, end);
            },
            focused: true
          },
          {
            field: 'apsGroupId',
            filter: true,
            column: 2,
            type: TYPE.TEXT,
            leftButton: {
              icon: 'fa-solid fa-arrow-right',
              command: event => {
                if (this.clearingExchApsIdFormatMap[this.formRecord.exchangeCode]) {
                  this.formRecord.apsGroupId = ApsIdFormat.format(this.clearingExchApsIdFormatMap[this.formRecord.exchangeCode], this.formRecord.orderReference);
                } else {
                  this.formRecord.apsGroupId = this.formRecord.orderReference;
                }
                this.refreshApsClass();
                this.ccFormDialog.reloadFieldValueMap();
              }
            },
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.apsGroupId = inputField.value;
              inputField.setSelectionRange(start, end);
              this.refreshApsClass();
              this.ccFormDialog.reloadFieldValueMap();
            },
            disabled: record => !this.apsManagement(),
          },
          {
            field: 'customerName',
            filter: true,
            column: 3,
            type: TYPE.AUTOCOMPLETE,
            options: (record, query) => {
              const opts: FieldRecord<any>[] = this.getDistinctOpts(this.displayedCustomers)
              return opts;
            },
            changed: event => {
              queueMicrotask(() => this.forceCustomerValues(this.formRecord, event.text, event.id));
            }
          },
          {
            field: 'accountCode',
            column: 3,
            type: TYPE.AUTOCOMPLETE,
            options: (record, query) => {
              return this.getDistinctOpts(this.filterAccounts(record, query));
            },
            changed: (event, record) => {
              queueMicrotask(() => this.forceAccountValues(record, event.text));
            }
          },
          {
            field: 'accountTypeCode',
            filter: true,
            column: 1,
            type: TYPE.AUTOCOMPLETE,
            options: (record) => this.getDistinctOpts(this.displayedAccountTypes),
          },
          {
            field: 'traderMemo',
            column: 1,
            type: TYPE.TEXT,
            max: 20,
            input: (event, formRecord, inputField) => {
              let start = inputField.selectionStart;
              let end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.traderMemo = inputField.value;
              inputField.setSelectionRange(start, end);
              this.originTraderMemo = formRecord.traderMemo;
            },
            hidden: record => {
              return !this.isRoleTraderMemoUpdate() || !this.appConfigService.iceTraderMemoFeature || !this.manageTraderMemo();
            }
          },
          {
            column: 1,
            type: TYPE.NONE,
            hidden: record => {
              return this.isRoleTraderMemoUpdate() && this.appConfigService.iceTraderMemoFeature && this.manageTraderMemo();
            }
          }
        ]
      },
      {
        group: '',
        hidden: record => AccountType.GIVE_UP_CODE === record.accountTypeCode,
        fields: this.getClearingFields()
      },
      {
        group: '',
        hidden: record => AccountType.GIVE_UP_CODE != record.accountTypeCode,
        fields: this.getGiveUpFields()
      },
    ];
  }

  // public filterCustomers() {
  //   if (this.customers && this.formRecord) {
  //     const owner = this.owners.find(value => value.id === this.formRecord.owner);
  //     this.displayedCustomers = this.customers.filter(field => {
  //       return !this.formRecord.owner || !owner || this.formRecord.owner === field.value.owner;
  //     });
  //   } else {
  //     this.displayedCustomers = [];
  //   }
  // }

  private getClearingFields(): FormFieldConfig[] {
    const fields: FormFieldConfig[] = [
      {
        field: 'openClose',
        filter: true,
        column: 2,
        type: TYPE.DROPDOWN,
        options: () => this.openCloses,
        hidden: () => {
          return !this.openCloseManagement();
        }
      },
      {
        field: 'reference1',
        column: 2,
        type: TYPE.TEXT,
        input: (event, formRecord, inputField) => {
          var start = inputField.selectionStart;
          var end = inputField.selectionEnd;
          inputField.value = inputField.value.toUpperCase();
          formRecord.reference1 = inputField.value;
          inputField.setSelectionRange(start, end);
        },
      },
      {
        field: 'reference2',
        column: 2,
        type: TYPE.TEXT
      },
      {
        field: 'reference3',
        column: 1,
        type: TYPE.TEXT
      },
      {
        column: this.appConfigService.billingEnabled ? 2 : 4,
        type: TYPE.NONE,
        hidden: () => {
          return this.openCloseManagement();
        }
      },
    ];
    if (this.appConfigService.billingEnabled) {
      fields.push({
          field: 'moneyOwner',
          column: 1,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.getDistinctOpts(this.moneyOwners),
        },
        {
          field: 'rate',
          column: 1,
          type: TYPE.TEXT,
        });
    }
    fields.push({
      field: 'currency',
      column: 1,
      type: TYPE.TEXT,
      input: (event, formRecord, inputField) => {
        var start = inputField.selectionStart;
        var end = inputField.selectionEnd;
        inputField.value = inputField.value.toUpperCase();
        formRecord.currency = inputField.value;
        inputField.setSelectionRange(start, end);
      },
    });

    if (this.appConfigService.billingEnabled) {
      fields.push({
        field: 'execTrader',
        column: 1,
        type: TYPE.AUTOCOMPLETE,
        options: (record) => this.getDistinctOpts(this.execTraders),
        changed: (event, record) => {
          queueMicrotask(() => this.setBrokerageRate(record));
        }
      });
    }
    fields.push(
      {
        field: 'traderName',
        filter: true,
        column: this.appConfigService.billingEnabled ? 1 : 2,
        type: TYPE.AUTOCOMPLETE,
        options: (record) => this.getDistinctOpts(this.filterTraders(record)),
      });

    return fields;
  }

  private getGiveUpFields(): FormFieldConfig[] {
    const fields: FormFieldConfig[] = [
      {
        field: 'giveUpBrokerCode',
        column: 2,
        type: TYPE.TEXT
      },
      {
        field: 'giveUpMessage',
        column: 2,
        type: TYPE.TEXT,
        input: (event, formRecord, inputField) => {
          var start = inputField.selectionStart;
          var end = inputField.selectionEnd;
          inputField.value = inputField.value.toUpperCase();
          formRecord.giveUpMessage = inputField.value;
          inputField.setSelectionRange(start, end);
        },
      },
      {
        field: 'giveUpMessage2',
        column: 1,
        type: TYPE.TEXT,
        hidden: record => {
          return !this.manageGiveUpMssg23();
        }
      },
      {
        field: 'giveUpMessage3',
        column: 1,
        type: TYPE.TEXT,
        hidden: record => {
          return !this.manageGiveUpMssg23();
        }
      },
      {
        field: 'broker',
        column: 1,
        type: TYPE.TEXT,
        hidden: record => {
          return this.manageGiveUpMssg23();
        }
      },
      {
        field: 'giveupAccountType',
        filter: true,
        column: 1,
        type: TYPE.AUTOCOMPLETE,
        options: (record) => this.getDistinctOpts(this.displayedGUpAccountTypes),
      },
      {
        column: this.appConfigService.billingEnabled ? 2 : 3,
        type: TYPE.NONE,
        hidden: record => {
          return this.manageGiveUpMssg23();
        }
      },
    ];

    if (this.appConfigService.billingEnabled) {
      fields.push({
          field: 'moneyOwner',
          column: 1,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.getDistinctOpts(this.moneyOwners),
        },
        {
          field: 'rate',
          column: 1,
          type: TYPE.TEXT,
        });
    }
    fields.push({
      field: 'currency',
      column: 1,
      type: TYPE.TEXT,
      input: (event, formRecord, inputField) => {
        var start = inputField.selectionStart;
        var end = inputField.selectionEnd;
        inputField.value = inputField.value.toUpperCase();
        formRecord.currency = inputField.value;
        inputField.setSelectionRange(start, end);
      },
    });

    if (this.appConfigService.billingEnabled) {
      fields.push({
        field: 'execTrader',
        column: 1,
        type: TYPE.AUTOCOMPLETE,
        options: (record) => this.getDistinctOpts(this.execTraders),
        changed: (event, record) => {
          queueMicrotask(() => this.setBrokerageRate(record));
        }
      });
    }
    fields.push({
      field: 'traderName',
      filter: true,
      column: this.appConfigService.billingEnabled ? 1 : 2,
      type: TYPE.AUTOCOMPLETE,
      options: (record) => this.getDistinctOpts(this.filterTraders(record)),
    });

    return fields;
  }
}
